import(/* webpackMode: "eager" */ "/workspace/aregncapital/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/ApproachSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/ChallengeSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/FinalCTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/SyndicateSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/TrackRecordSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/WhatMakesDifferentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/WhatWeDoSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/components/WhoWeWorkWithSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/components/ui/AppLogo.tsx");
